import React from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { scrollToSection } from "@/storefront/registry";
import { trackInteraction } from "@/storefront/trackInteraction";
import { telHref } from "@/lib/phone";

/** The sticky mobile bar. Storefront S5 (gap review item 9): matches the handoff's exact pattern
 * now — one full-width primary pill + a round, icon-only call button (`*.dc.html` MOBILE BAR,
 * every vertical) — not three equal-width buttons with a text "Call"/"WhatsApp". WhatsApp has no
 * slot in the handoff's mobile bar (it's a full rail button on desktop); dropping it here isn't a
 * regression since Call is always reachable and WhatsApp still shows in the desktop `ContactRail`.
 * Same visibility rule as before (hidden unless there's a primary action or a phone), and the
 * primary button still scrolls to its section rather than switching a tab. `pb-28` on the page
 * root (`Storefront.jsx`) keeps this bar from covering the last section's content. */
export function MobileActionBar({ business, primaryAction }) {
  if (!primaryAction && !business.phone) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 flex items-center gap-2 border-t border-border bg-background/95 px-4 pt-2.5 pb-[calc(0.625rem+env(safe-area-inset-bottom))] backdrop-blur md:hidden"
      data-testid="mini-site-action-bar"
    >
      {primaryAction && (
        <Button
          className="h-[46px] flex-1 rounded-full text-sm font-bold"
          data-testid="mini-site-bar-primary"
          onClick={() => scrollToSection(primaryAction.key)}
        >
          {primaryAction.label}
        </Button>
      )}
      {telHref(business.phone) && (
        <Button
          asChild
          variant="outline"
          size="icon"
          className="h-[46px] w-[46px] shrink-0 rounded-full"
          data-testid="mini-site-bar-call"
          onClick={() => trackInteraction(business.id, "call")}
        >
          <a href={telHref(business.phone)} aria-label="Call">
            <Phone size={18} className="text-[hsl(var(--primary))]" />
          </a>
        </Button>
      )}
    </div>
  );
}
